import BaseIconSvg from '@/components/bases/BaseIconSvg';
import emrTypeHelper from '@/helper/emrType';
import useActions from '@/hooks/useActions';
import FormCreateEmr from '@/screens/CreateEmr/FormCreateEmr';
import FormEditTagsEmr from '@/screens/CreateEmr/FormEditTagsEmr';
import useGlobalConfigs from '@/stores/globalConfigs';
import { IQuickModalResult, useQuickModal } from '@/utils/quickModal';
import { Dropdown, message } from 'antd';
import { MenuProps } from 'antd/lib';
import * as React from 'react';

export interface IEmrActionProps {
  items?: MenuProps['items'];
  children?: React.ReactNode;
  emr: IEMRData;
  onOk?: (_: IQuickModalResult) => void;
}

const EmrAction: React.FC<IEmrActionProps> = ({ emr, onOk, children, ...props }) => {
  const { quickModal, quickModalContext } = useQuickModal();
  const { isCMSView } = useActions();
  const getEmrType = useGlobalConfigs((s) => s.getEmrType);
  const emrType = getEmrType(emr?.type?.code);
  return !isCMSView ? (
    <>
      {quickModalContext}
      <Dropdown
        trigger={['click']}
        menu={{
          items: [
            {
              key: 'edit',
              label: 'Chỉnh sửa',
              icon: <BaseIconSvg src="/icons/Regular/Edit - icon.svg" />,
              onClick: () => {
                if (!emrTypeHelper.canEdit(emr)) {
                  return message.warning(`Không thể sửa bản ghi được tạo ra từ hệ thống khác (${emr?.race})`);
                }
                quickModal.custom({
                  width: 900,
                  title: emrType?.name,
                  content: (
                    <FormCreateEmr disabled={false} emrTypeStringInit={emr?.type.code} initValues={emr} onOk={onOk} />
                  ),
                });
              },
            },
            {
              key: 'addTag',
              label: 'Gắn thẻ',
              icon: <BaseIconSvg src="/icons/Regular/Tag - icon.svg" />,
              onClick: () => {
                quickModal.custom({
                  width: 900,
                  title: 'Gắn thẻ',
                  content: <FormEditTagsEmr emr={emr as IEMRData} />,
                });
              },
            },
          ].filter(Boolean),
        }}
        className="hover:text-mint-8 cursor-pointer pointer-events-auto"
        rootClassName="hover:[&_.ant-dropdown-menu-item]:text-mint-8"
      >
        <BaseIconSvg src="/icons/Regular/Settings - icon.svg" />
      </Dropdown>
    </>
  ) : null;
};
export default EmrAction;
